module.exports = __webpack_public_path__ + "static/media/banescoLogoBG.05054e5a.svg";